import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-price-register",
  "use": "icon-price-register-usage",
  "viewBox": "0 0 14 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 16\" id=\"icon-price-register\"><path d=\"M11.5 3a8.354 8.354 0 0 0-8.207-.366l-.298.15a2.684 2.684 0 0 0-1.426 2.881l.012.065A2.772 2.772 0 0 0 4.308 8H9c1.197 0 2.266.77 2.66 1.9a2.796 2.796 0 0 1-1.467 3.46 9.269 9.269 0 0 1-8.987-.722L1 12.5\" stroke=\"#fff\" stroke-width=\"3\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol